import { render, staticRenderFns } from "./linkButton.vue?vue&type=template&id=5c884e30&"
import script from "./linkButton.vue?vue&type=script&lang=js&"
export * from "./linkButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports